import { Routes } from '@angular/router';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { APP_PATHS } from '../../shared/constants/routes.constants';
import { AuthLayoutSignupComponent } from './auth-layout/auth-layout-content/auth-layout-signup/auth-layout-signup.component';
import { AuthLayoutResetPasswordComponent } from './auth-layout/auth-layout-content/auth-layout-reset-password/auth-layout-reset-password.component';
import { UserDisplayComponent } from './auth-layout/auth-layout-content/user-display/user-display.component';
import { RESET_PASSWORD_FEATURE_KEY } from './reset-password/state/reset-password.constants';
import { resetPasswordReducer } from './reset-password/state/reset-password.reducer';
import { ResetPasswordEffects } from './reset-password/state/reset-password.effects';

export const authRoutes: Routes = [
  {
    path: APP_PATHS.AUTH,
    loadComponent: () =>
      import('./auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: APP_PATHS.LOGIN,
        pathMatch: 'full',
      },
      {
        path: APP_PATHS.LOGIN,
        loadComponent: () => import('./log-in/log-in.component').then((m) => m.LogInComponent),
        data: {
          content: UserDisplayComponent,
          imageSrc: '/assets/images/auth-aside-img.jpg',
        },
      },
      {
        path: APP_PATHS.SIGNUP,
        loadComponent: () => import('./sign-up/sign-up.component').then((m) => m.SignUpComponent),
        data: {
          content: AuthLayoutSignupComponent,
          imageSrc: '/assets/images/auth-aside-img.jpg',
        },
      },
      {
        path: APP_PATHS.RESET_PASSWORD,
        loadComponent: () =>
          import('./reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
        providers: [
          provideState({ name: RESET_PASSWORD_FEATURE_KEY, reducer: resetPasswordReducer }),
          provideEffects(ResetPasswordEffects),
        ],
        data: {
          content: AuthLayoutResetPasswordComponent,
          imageSrc: '/assets/images/reset-password-security.jpg',
        },
      },
    ],
  },
];
